import { createContext } from "react";

const StudentPaymentContext = createContext();

export default StudentPaymentContext;